import React from 'react';

const Loader = ({ fullscreen = false }) => {
  if (fullscreen) {
    return (
      <div className="loader-overlay">
        <div className="loader"></div>
      </div>
    );
  }
  
  return <div className="loader"></div>;
};

export default Loader;